// src/components/Header.jsx
import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import AnimatedNavLink from "./AnimatedNavLink";

const NAV_ITEMS = [
  { id: "home",     label: "Home",     type: "scroll" },
  { id: "story",    label: "Story",    type: "scroll" },
  { id: "games",    label: "Games",    type: "route", path: "/games" },
  { id: "presskit", label: "Presskit", type: "scroll" },
  { id: "news",     label: "News",     type: "route", path: "/news" },
  { id: "contact",  label: "Contact",  type: "scroll" },
];

export default function Header() {
  const location   = useLocation();
  const navigate   = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMenu  = () => setMobileOpen((p) => !p);

  const handleScroll = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      const section = document.getElementById(id);
      if (!section) return;
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleNav = (item) => {
    if (item.type === "route") {
      navigate(item.path);
      return;
    }
    handleScroll(item.id);
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-black/70 backdrop-blur text-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
        {/* ─── logo – now PNG ─────────────────────────────────── */}
        <img
          src={`${process.env.PUBLIC_URL}/images/twinframe_logo.png`}
          alt="TwinFrame logo"
          className="h-13 md:h-15 lg:h-17 max-w-[190px] w-auto cursor-pointer select-none"
          onClick={() => handleScroll("home")}
        />

        {/* ─── desktop nav ───────────────────────────────────── */}
        <nav className="hidden md:flex gap-6 text-sm md:text-base items-center">
          {NAV_ITEMS.map((item) => (
            <AnimatedNavLink key={item.id} onClick={() => handleNav(item)}>
              {item.label}
            </AnimatedNavLink>
          ))}
        </nav>

        {/* ─── hamburger (mobile) ────────────────────────────── */}
        <button
          aria-label="Menu"
          className="md:hidden text-white focus:outline-none"
          onClick={toggleMenu}
        >
          {mobileOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* ─── dropdown menu (mobile) ─────────────────────────── */}
      {mobileOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur px-6 pb-6 space-y-4">
          {NAV_ITEMS.map((item) => (
            <AnimatedNavLink
              key={item.id}
              onClick={() => { toggleMenu(); handleNav(item); }}
              className="block w-full text-left text-lg py-2"
            >
              {item.label}
            </AnimatedNavLink>
          ))}
        </div>
      )}
    </header>
  );
}
